import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Button } from 'reactstrap';
import { SegmentedStepper } from '@dev-go4ellis/go4-design-system';
import { trackMixpanelPageView } from 'helpers/post';
import { withQueryParamCapture } from '@helpers/useQueryParamCapture';
import { getFunnelStepperConfig } from '../funnelSteps';
import './OrganizationDetails.scss';

// Step three of the updated Job Poster funnel (GO4-1736). The progress stepper is rendered
// centered in the top navigation — see scenes/V3/CreateAccountScene/funnelSteps.

const STORAGE_KEYS = {
  organizationName: 'registrationOrganizationName',
  organizationWebsite: 'registrationOrganizationWebsite',
  zipCode: 'registrationZipCode',
  submitted: 'registrationOrgDetailsSubmitted',
};

const ZIP_REGEX = /^\d{5}(-\d{4})?$/;

class OrganizationDetails extends Component {
  constructor(props) {
    super(props);

    const wasSubmitted = localStorage.getItem(STORAGE_KEYS.submitted) === 'true';

    this.state = {
      organizationName: wasSubmitted ? localStorage.getItem(STORAGE_KEYS.organizationName) || '' : '',
      organizationWebsite: wasSubmitted ? localStorage.getItem(STORAGE_KEYS.organizationWebsite) || '' : '',
      zipCode: wasSubmitted ? localStorage.getItem(STORAGE_KEYS.zipCode) || '' : '',
      zipError: false,
    };
  }

  componentDidMount() {
    trackMixpanelPageView('/create-account/organization-details');
  }

  isValidZip = value => ZIP_REGEX.test(value.trim());

  onNameChange = e => {
    this.setState({ organizationName: e.target.value });
  };

  onWebsiteChange = e => {
    this.setState({ organizationWebsite: e.target.value });
  };

  onZipChange = e => {
    this.setState({ zipCode: e.target.value });
    if (this.state.zipError) {
      this.setState({ zipError: false });
    }
  };

  onContinue = () => {
    const { organizationName, organizationWebsite, zipCode } = this.state;
    const trimmedName = organizationName.trim();
    const trimmedWebsite = organizationWebsite.trim();
    const trimmedZip = zipCode.trim();

    if (!this.isValidZip(trimmedZip)) {
      this.setState({ zipError: true });
      return;
    }

    localStorage.setItem(STORAGE_KEYS.organizationName, trimmedName);
    localStorage.setItem(STORAGE_KEYS.organizationWebsite, trimmedWebsite);
    localStorage.setItem(STORAGE_KEYS.zipCode, trimmedZip);
    // Mark as submitted so the next mount (via Back) pre-fills from storage.
    localStorage.setItem(STORAGE_KEYS.submitted, 'true');

    this.props.history.push('/sign-up');
  };

  trackLogin = () => {
    trackMixpanelPageView('IntroLogInClick');
  };

  render() {
    const { organizationName, organizationWebsite, zipCode, zipError } = this.state;
    const buttonDisabled = !organizationName.trim() || !zipCode.trim();
    const funnelStepper = getFunnelStepperConfig('/create-account/organization-details');

    return (
      <div className="organization-details">
        {funnelStepper && (
          <div className="organization-details-mobile-stepper">
            <SegmentedStepper total={funnelStepper.total} current={funnelStepper.current} size="sm" />
          </div>
        )}
        <main>
          <header>
            <div className="screen-title gotham-bold-font">Organization info and location</div>
          </header>
          <div className="content">
            <div className="form-fields">
              <div className="form-field">
                <label htmlFor="organizationName">Organization name</label>
                <input
                  id="organizationName"
                  type="text"
                  className="form-input"
                  placeholder="School, clinic, industry or club's name"
                  value={organizationName}
                  onChange={this.onNameChange}
                />
              </div>

              <div className="form-field">
                <label htmlFor="organizationWebsite">Organization website</label>
                <input
                  id="organizationWebsite"
                  type="text"
                  className="form-input"
                  placeholder="www..."
                  value={organizationWebsite}
                  onChange={this.onWebsiteChange}
                />
              </div>

              <div className="form-field">
                <label htmlFor="zipCode" className={zipError ? 'label-error' : ''}>
                  Zip code
                </label>
                <input
                  id="zipCode"
                  type="text"
                  inputMode="numeric"
                  className={`form-input ${zipError ? 'input-error' : ''}`}
                  placeholder="00000"
                  value={zipCode}
                  onChange={this.onZipChange}
                />
                {zipError && <div className="error-text">Add a valid zip code</div>}
              </div>
            </div>
          </div>
        </main>
        <div className="navigation-buttons">
          <div className="nav-login-container">
            <div className="nav-login-text">Already have an account?</div>
            <Link to="/" onClick={this.trackLogin} className="login-btn gotham-medium-font">
              <div>Log In</div>
            </Link>
          </div>
          <Button onClick={this.onContinue} className="continue-button" disabled={buttonDisabled}>
            <div>Continue &#8594;</div>
          </Button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  authenticated: state.session.authenticated,
  user: state.session.currentUser,
});

// Wrap with HOC to automatically capture query parameters
export default withQueryParamCapture(connect(mapStateToProps)(OrganizationDetails));
